import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { getSectionData, getSectionMetaData } from '@/APIs/sectionApi';

export default function useSection({ id, fetchSections = false } = {}) {
    const { data: sectionMetaData, isLoading: sectionMetaDataLoading } = useQuery({
        queryKey: ['getSectionMetaData', id],
        queryFn: () => getSectionMetaData({ id }),
        staleTime: 0,
        enabled: fetchSections
    });
    const isLogData = sectionMetaData?.content_generator === 'Stream Log';
    const isRecommendation =
        sectionMetaData?.content_generator === 'Recommendation' || id === 'recommendation';
    const isVideoLog = sectionMetaData?.content_type === 'Video';

    const {
        data: sectionData,
        isFetching: sectionDataIsFetching,
        isFetchingNextPage: sectionDataIsFetchingNextPage,
        fetchNextPage: sectionDataFetchNextPage
    } = useInfiniteQuery({
        queryKey: ['getSection', id],
        queryFn: (input) => {
            return getSectionData({
                id,
                next: input?.pageParam
            });
        },
        getNextPageParam: (lastPage) => {
            return lastPage?.links?.next || undefined;
        },
        staleTime: 30 * 60 * 1000,
        enabled: fetchSections && !isRecommendation && !sectionMetaDataLoading && !isLogData
    });

    return {
        sectionMetaDataLoading,
        sectionMetaData,
        sectionDataIsFetching,
        sectionData,
        sectionDataIsFetchingNextPage,
        sectionDataFetchNextPage,
        isLogData,
        isVideoLog,
        isRecommendation
    };
}
